import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow';
import EdgeLabelWithEdit from './EdgeLabelWithEdit';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  style,
  source,
  target
}) => {
  const isSelfConnecting = source === target;
  
  let edgePath = '';
  let labelX = 0;
  let labelY = 0;

  if (isSelfConnecting) {
    // Create a self-connecting circular loop below the node
    const radius = 40;
    const centerY = sourceY + radius + 20; // Move circle below the node
    
    // Create a circular path that starts and ends at the bottom of the node
    edgePath = `M ${sourceX} ${sourceY} 
                L ${sourceX} ${sourceY + 20}
                C ${sourceX - radius} ${centerY},
                  ${sourceX + radius} ${centerY},
                  ${sourceX} ${sourceY + 20}
                L ${sourceX} ${sourceY}`;
    
    // Position label below the loop
    labelX = sourceX;
    labelY = centerY + 10;
  } else {
    // Normal edge path
    [edgePath, labelX, labelY] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });
  }

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        className="dialog-edge-path"
        style={{
          ...style,
          strokeWidth: isSelfConnecting ? 2 : style?.strokeWidth || 1.5,
          stroke: isSelfConnecting ? '#0f766e' : style?.stroke || '#53657c',
        }} 
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          className="dialog-edge-label-wrap nodrag nopan"
        >
          <EdgeLabelWithEdit
            label={data?.label || 'User Responded'}
            onChange={(newLabel) => data?.onLabelChange(id, newLabel)}
          />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge; 
